import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "py-2" };
const _hoisted_2 = { class: "text-caption text-disabled mt-1 uuid-text" };
const _hoisted_3 = {
    key: 0,
    class: "mt-2 d-flex flex-wrap ga-1"
};
import { computed } from "vue";
import { useStore } from "@/store";
import { formatDate } from "@/utils/dateUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DatasetTable',
    props: {
        datasetHits: {}
    },
    emits: ["update-dataset"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const selected = computed(() => {
            return store.current_dataset_index;
        });
        function updateSelectedDataset(index) {
            store.updateCurrentDatasetIndex(index);
            store.updateCurrentDataset(props.datasetHits[index]);
            emit("update-dataset");
        }
        return (_ctx, _cache) => {
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            return (_openBlock(), _createBlock(_component_v_list, {
                class: "dataset-list pa-2",
                "bg-color": "transparent"
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.datasetHits, (dataset, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: dataset.uri || index,
                            active: selected.value === index,
                            onClick: ($event) => (updateSelectedDataset(index)),
                            rounded: "lg",
                            class: _normalizeClass(["dataset-item mb-1", { 'dataset-item--active': selected.value === index }])
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createVNode(_component_v_list_item_title, { class: "text-body-1 font-weight-medium mb-1" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(dataset.name), 1)
                                        ]),
                                        _: 2
                                    }, 1024),
                                    _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 text-medium-emphasis d-flex align-center ga-2" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                                size: "x-small",
                                                class: "mr-1"
                                            }, {
                                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                        _createTextVNode("mdi-account", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _createTextVNode(" " + _toDisplayString(dataset.creator_username) + " ", 1),
                                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mx-1" }, "·", -1)),
                                            _createVNode(_component_v_icon, {
                                                size: "x-small",
                                                class: "mr-1"
                                            }, {
                                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                        _createTextVNode("mdi-calendar", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _createTextVNode(" " + _toDisplayString(_unref(formatDate)(dataset.created_at)), 1)
                                        ]),
                                        _: 2
                                    }, 1024),
                                    _createElementVNode("div", _hoisted_2, _toDisplayString(dataset.uuid), 1),
                                    (dataset.tags && dataset.tags.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataset.tags, (tag, tagIndex) => {
                                                return (_openBlock(), _createBlock(_component_v_chip, {
                                                    key: tagIndex,
                                                    size: "small",
                                                    variant: "tonal",
                                                    color: "primary",
                                                    label: ""
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(tag), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _: 2
                        }, 1032, ["active", "onClick", "class"]));
                    }), 128))
                ]),
                _: 1
            }));
        };
    }
});
